import { Box, Button, Grid, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { AppUrl } from "../../config";
import { ResultRecord } from "../../interfaces";
import LeavingFDICDialog from "../LeavingFDICDialog";

const useStyles = makeStyles(theme => ({
  list: {
    marginTop: 0,
    marginBottom: "2rem",
    color: theme.palette.primary.main,
    fontSize: 16,
  },
}));

interface Props {
  institution: ResultRecord;
}

export default function BankFindFinancials({ institution }: Props) {
  const styles = useStyles();
  const cert = institution.CERT;
  const risDateMonth = institution.RISDATE.substring(0, 2);
  const risDateDay = institution.RISDATE.substring(3, 5);
  const risDateYear = institution.RISDATE.substring(6, 10);
  const risdate = `${risDateMonth}${risDateDay}${risDateYear}`;

  const risDictLink =
    "https://www7.fdic.gov/DICT/app/templates/Index.html#!/Main";
  const bfsLinks = (
    <>
      <Typography color="primary" variant="h6">
        Financial Reports on BankFind Suite
      </Typography>
      <ul className={styles.list}>
        <li>Run Standard Reports</li>
        <li>Create Customized Selection</li>
        <li>
          Data Source: View the <a href={risDictLink}>RIS Dictionary</a>
        </li>
      </ul>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Button
            variant="outlined"
            fullWidth
            color="primary"
            id="financials-reporting-btn"
            href={`/bankfind-suite${AppUrl(
              "FinancialReporting",
            )}/report?cert=${cert}&prev=/bankfind/details/${cert}?bankfindLevelThreeView=Financials`}
          >
            Financial Reporting
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="outlined"
            fullWidth
            color="primary"
            id="bod-btn"
            href={`/bankfind-suite${AppUrl(
              "SOD",
            )}/branchOffice?cert=${cert}&displayResult&prev=/bankfind/details/${cert}?bankfindLevelThreeView=Financials`}
          >
            Branch Office Deposits
          </Button>
        </Grid>
      </Grid>
    </>
  );

  const externalLinks = (
    <>
      <Typography color="primary" variant="h6">
        External Links to Financial Information
      </Typography>
      <Typography className={styles.list}>
        The following links are provided to give you access to the most recent
        reports submitted.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <LeavingFDICDialog
            webAddress={`https://cdr.ffiec.gov/Public/ViewFacsimileDirect.aspx?ds=call&idType=fdiccert&id=${cert}&date=${risdate}`}
            label={"Latest FFIEC Call Report"}
            noHover
            button
            buttonProps={{ color: "primary", variant: "outlined" }}
          />
        </Grid>
        <Grid item xs={6}>
          <LeavingFDICDialog
            webAddress={`https://cdr.ffiec.gov/Public/ViewFacsimileDirect.aspx?ds=ubpr&repType=1&idType=fdiccert&id=${cert}`}
            label={"Latest UBPR Report"}
            noHover
            button
            buttonProps={{ color: "primary", variant: "outlined" }}
          />
        </Grid>
      </Grid>
    </>
  );

  return (
    <Box width="100%">
      <Grid container spacing={2}>
        <Grid item xs={6}>
          {bfsLinks}
        </Grid>
        <Grid item xs={6}>
          {externalLinks}
        </Grid>
      </Grid>
    </Box>
  );
}
